/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { Container, Row } from "reactstrap";

import FooterMessageBar from "./FooterMessageBar";

// core context
import {NotificationContextConsumer} from "../Context/NotificationContext"


function FooterBlack() {
  //let history = useHistory();

  return (
    <>
      <footer className="footer footer-black">
        <Container>
          <Row>
            <nav id="footer-navigation" className="footer-nav">
              <ul>
                <li>
                  <Link to="/privacy" className="mr-1">Privacy</Link>
                </li>
                <li>
                    <a 
                        href={`${process.env.REACT_APP_API_URL}/users/terms-and-conditions`}
                        className="mr-1"
                        target="_blank"
                    >
                        Terms and Conditions
                    </a>
                </li>
                <li>
                  <Link to="/hiring" className="mr-1">Work with Lazybones</Link>
                </li>
                <li>
                  <a
                    href="#"
                    target="_blank"
                    className="mr-1"
                  > 
                    Contact Us - 1-877-215-2105
                  </a>  
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <span className="copyright">
                © {new Date().getFullYear()}
                , Lazybones
              </span>
            </div>
          </Row>
        </Container>
      </footer>
      {
        <NotificationContextConsumer>
          {
            (notificationData)=><FooterMessageBar {...notificationData} />
          }
        </NotificationContextConsumer>
       }
    </>
  );
}

export default FooterBlack;
